import { css } from '@/styled-system/css';

export const desktopHeader = css({
  display: 'none',
  md: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '56px',
    px: '4x',
    py: '2x',
    position: 'sticky',
    top: 0,
    bg: 'hpxWhite',
    zIndex: 'zIndexParent',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'hpxGrey400',
  },
});

export const desktopHeaderColumns = css({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  width: '100%',
  gap: '2x',
});

export const desktopHeaderLeft = css({
  justifySelf: 'start',
});

export const desktopHeaderCenter = css({
  justifySelf: 'center',
  overflow: 'hidden',
});

export const desktopHeaderRight = css({
  justifySelf: 'end',
  display: 'flex',
  gap: '2x',
  alignItems: 'center',
});

export const backButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  bg: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: 'hpxBlue600',
  fontSize: 'sm',
  fontWeight: 'bold',
  fontFamily: 'inherit',
  padding: '1x',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
  _hover: {
    bg: 'hpxGrey100',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const listingName = css({
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  margin: 0,
});

export const actionWithLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
});

export const actionLabel = css({
  display: 'none',
  fontSize: 'tiny',
  color: 'hpxBlue500',
  xxl: {
    display: 'inline',
  },
});
